var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-padded-vertical"},[_c('Box',{attrs:{"flat":"","black":_vm.$themeDark}},[_c('Title',[_vm._v("Unknown Product")]),_c('p',[_vm._v(" Please contact customer support. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }